export default "__VITE_ASSET__YOr3MQcl__"